import React, { SelectHTMLAttributes } from 'react'
import { map } from 'underscore'

import styled from 'styled-components'

import LabelledField from 'components/LabelledField'

export interface SelectOption {
  name: string
  value: string | number
}

export interface SelectOptionGroup {
  label: string
  options: Array<SelectOption>
}

type Props = SelectHTMLAttributes<HTMLSelectElement> & {
  label?: string,
  selectOptions: Array<Array<SelectOption>> | Array<SelectOptionGroup>
  isRequired?: boolean,
  errorMessage?: string,
  className?: string
}

const Select = ({ label = '', selectOptions, isRequired = false, errorMessage = '', className = '', ...inputProps } : Props) => {
  const id = label ? label.replace(' ', '_') : label

  const options = (optgroup) => map(optgroup, (option) => {
    return <option key={option.value} value={option.value}>{option.name}</option>
  })

  const optgroups = map(selectOptions, (optgroup: Array<SelectOption> | SelectOptionGroup) => {
    if (Array.isArray(optgroup)) {
      return options(optgroup)
    } else {
      return (
        <optgroup key={optgroup.label} label={optgroup.label}>
          {options(optgroup.options)}
        </optgroup>
      )
    }
  })

  return (
    <LabelledField {...{ id, label, isRequired, errorMessage, className }}>
      <S.Select {...{ id, ...inputProps }}>
        {optgroups}
      </S.Select>
    </LabelledField>
  )
}

export default Select

const S = {
  Select: styled.select`
    padding: 6px 26px 6px 7px;
    font-size: initial;
    text-transform: inherit;
    font-weight: inherit;
    font-family: inherit;
    color: inherit;
    height: 39px;
    border-radius: 4px;
  `
}
